const WELCOME_GUIDE_DAYS = 15;

export const hasCompletedStoreAudit = (lastAuditDate?: string | null) => Boolean(lastAuditDate);

export const isStoreInTrialPeriod = (subscriptionStatus?: string | null) =>
  subscriptionStatus === "trial";

export const isStoreWelcomePreviewEnabled = (
  welcomePreviewParam: string | null,
  environment: string | undefined
) => environment === "development" && welcomePreviewParam === "1";

export const shouldHighlightWelcomeGuide = (
  storeCreatedAt?: string | null,
  now: Date = new Date()
) => {
  if (!storeCreatedAt) {
    return false;
  }

  const createdAt = new Date(storeCreatedAt);
  if (Number.isNaN(createdAt.getTime())) {
    return false;
  }

  const guideExpiresAt = new Date(createdAt);
  guideExpiresAt.setDate(guideExpiresAt.getDate() + WELCOME_GUIDE_DAYS);
  return now.getTime() < guideExpiresAt.getTime();
};
